import slice from "./costDriversSlice";

export default slice.reducer;
